import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const thousandFormatter = (n: number) => n / 1000

const tonneFormatter = (n: number) => +(n / 1000000)

const BarChart = ({
  datasets,
  labels,
  barThickness,
  legendPosition,
  alignLegend,
  showLabelDisplay,
  tonnes,
}: {
  datasets: any
  labels: any
  barThickness?: number
  legendPosition?: 'top' | 'bottom' | 'left' | 'right'
  alignLegend?: 'center' | 'start' | 'end'
  showLabelDisplay?: boolean
  tonnes?: boolean
}) => {
  const data = {
    labels,
    datasets,
  }

  const options = {
    maintainAspectRatio: false,
    barThickness: barThickness ? barThickness : 40,
    plugins: {
      legend: {
        position: legendPosition ? legendPosition : 'bottom',
        align: alignLegend ? alignLegend : 'center',
        display: showLabelDisplay,
        labels: {
          boxHeight: 12,
          boxWidth: 12,
          padding: 20,
        },
      },
      tooltips: {
        mode: 'index' as 'index',
        callbacks: {
          title: function () {},
        },
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 30,
          // minRotation: 90,
        },
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: {
          callback: (label: any) => (tonnes ? tonneFormatter(label) : thousandFormatter(label)),
        },
        grid: {
          drawBorder: false,
        },
      },
    },
    // ticks: {
    //   stepSize: 5,
    // },
  }

  return <Bar data={data} options={options} />
}

export default BarChart
